import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientProfile from './pages/ClientProfile';
import Projects from './pages/Projects';
import Invoices from './pages/Invoices';
import Maintenance from './pages/Maintenance';
import Documents from './pages/Documents';
import Users from './pages/Users';
import Sidebar from './components/Sidebar';

function App() {
  const [token, setToken] = useState(localStorage.getItem('crm_token'));
  const [role, setRole] = useState(localStorage.getItem('crm_role'));
  const [userName, setUserName] = useState(localStorage.getItem('crm_name'));

  const handleLogin = (newToken, newRole, newName) => {
    localStorage.setItem('crm_token', newToken);
    localStorage.setItem('crm_role', newRole);
    localStorage.setItem('crm_name', newName);
    setToken(newToken);
    setRole(newRole);
    setUserName(newName);
  };

  const handleLogout = () => {
    localStorage.removeItem('crm_token');
    localStorage.removeItem('crm_role');
    localStorage.removeItem('crm_name');
    setToken(null);
    setRole(null);
    setUserName(null);
  };

  if (!token) {
    return (
      <>
        <Toaster position="top-right" />
        <Login onLogin={handleLogin} />
      </>
    );
  }

  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <div style={{ display: 'flex', minHeight: '100vh', background: '#0e0804' }}>
        <Sidebar onLogout={handleLogout} role={role} userName={userName} token={token} />
        <div style={{ flex: 1, marginLeft: '240px', padding: '2rem', overflowY: 'auto' }} className="main-content">
          <Routes>
            <Route path="/" element={<Dashboard token={token} role={role} />} />
            <Route path="/clients" element={<Clients token={token} role={role} />} />
            <Route path="/clients/:id" element={<ClientProfile token={token} role={role} />} />
            <Route path="/projects" element={<Projects token={token} role={role} />} />
            <Route path="/invoices" element={<Invoices token={token} role={role} />} />
            <Route path="/maintenance" element={<Maintenance token={token} role={role} />} />
            <Route path="/documents" element={<Documents token={token} role={role} />} />
            {(role === 'owner' || role === 'admin') && (
              <Route path="/users" element={<Users token={token} role={role} />} />
            )}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </div>
      <style>{`
        @media (max-width: 768px) {
          .main-content { margin-left: 0 !important; padding: 5rem 1rem 2rem !important; }
        }
      `}</style>
    </BrowserRouter>
  );
}

export default App;